import React from 'react'

import {
  DefaultContainer,
  MainContainer,
  SummaryContainer,
} from '../../ui-view/loader-spinner'

function LoaderSpinner() {
  return (
    <div className="lds-roller">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  )
}

function AppSpinner() {
  return (
    <MainContainer>
      <LoaderSpinner />
    </MainContainer>
  )
}

function Spinner() {
  return (
    <DefaultContainer>
      <LoaderSpinner />
    </DefaultContainer>
  )
}

function SummarySpinner() {
  return (
    <SummaryContainer role="status" aria-live="polite">
      <LoaderSpinner />
      <span
        style={{
          fontFamily: 'Open Sans',
          fontSize: '13px',
          color: '#4D4D4D',
        }}
      >
        Loading your order summary...
      </span>
    </SummaryContainer>
  )
}

export {AppSpinner, Spinner, SummarySpinner}
